import { v4 as createId } from 'uuid';
import { autorun } from 'mobx';

import { toasterStore } from './toasterStore';
import { ToastMessages, ToastTypes } from './utils';

class ToasterService {
  constructor() {
    autorun(() => {
      this._ticker = null;
      if (!toasterStore.list.length) {
        clearInterval(this._ticker);
        this._ticker = null;
      }
    });
  }

  /**
   * @name handleErrorMessageWithValidationType
   * @param {ERROR_TYPES} validationType
   */
  handleErrorMessageWIthMessageCode(validationType) {
    const message = ToastMessages[validationType] || ToastMessages._;
    const type = ToastTypes[validationType] || ToastTypes._;
    const duration = 1500;
    this.notify({ message, type, duration });
  }


  notify({ message, type, duration }) {
    const toast = this._createToast({ message, type, duration });
    this._registerQueue(toast);
    toasterStore.addToast(toast);
  }

  /**
   * @name _registerQueue
   * @param {Toast} toast
   * @private
   */
  _registerQueue(toast) {
    if (!toasterStore.list.length) {
      clearInterval(this._ticker);
      this._ticker = setInterval(() => {
        const now = Date.now();
        toasterStore.list.forEach(({ id, _start, duration }) => {
          if (now - _start >= duration) {
            toasterStore.removeToast(id);
          }
        });
      }, 500);
    }
  }

  /**
   * @name _createToast
   * @param {any} message
   * @param {number=} duration
   * @param {ToasterMessageType} type
   * @returns {Toast}
   * @private
   */
  _createToast({ message, type, duration = 2000 }) {
    return {
      id: createId(),
      message,
      type,
      duration,
      _start: Date.now(),
    };
  }
}

export const toasterService = new ToasterService();